// @ts-check
import { AlertTriangle, ArrowDown, ArrowUp, Minus } from 'lucide-react';

const PRIORITY_CONFIG = {
  low: {
    label: 'Low',
    color: 'bg-muted text-foreground/80 border-input',
    icon: ArrowDown,
  },
  medium: {
    label: 'Medium',
    color:
      'bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300 border-yellow-300 dark:border-yellow-800',
    icon: Minus,
  },
  high: {
    label: 'High',
    color:
      'bg-orange-100 dark:bg-orange-900/40 text-orange-800 dark:text-orange-300 border-orange-300 dark:border-orange-800',
    icon: ArrowUp,
  },
  urgent: {
    label: 'Urgent',
    color: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800',
    icon: AlertTriangle,
  },
};

const TaskPriorityBadge = ({ priority, showIcon = true, size = 'md' }) => {
  const config = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-0.5',
    lg: 'text-base px-3 py-1',
  };

  const iconSizes = {
    sm: 12,
    md: 14,
    lg: 16,
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${config.color} ${sizeClasses[size]}`}
    >
      {showIcon && <Icon size={iconSizes[size]} />}
      {config.label}
    </span>
  );
};

export default TaskPriorityBadge;
